
import {
  computed,
  defineComponent,
  nextTick,
  onMounted,
  onUnmounted,
  ref,
  watch,
} from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import Rating from "../Rating.vue";
import VideoCustom from "@/components/VideoCustom.vue";
import { Modal } from "bootstrap";
import axios from "axios";
import { useRoute, useRouter } from "vue-router";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
const videoReload = ref(0);
const showSeeking = ref(false);
const maxReachedTime = ref(0);
const currentVideo = ref();
const currentYoutube = ref();
const listData = ref();
const listSection = ref();
const videoRef = ref();
const currentChId = ref();
const showDetail = ref(true);
const showDocument = ref(false);
const showBookmark = ref(false);
const listDocument = ref();
const showYoutube = ref(false);
const showVideo = ref(false);
const currentUpdate = ref({
  sectionId: "",
  chapterId: "",
  flgSuccess: false,
});
const currentDuration = ref(0);
const courseRegister = ref();
const shownQuizChapters = ref<Set<string>>(new Set());
const quizTimeoutHandle = ref<number | null>(null);
const quizInterrupted = ref(false);

export default defineComponent({
  name: "mandatory-learn",
  components: {
    Rating,
    VideoCustom,
  },
  data() {
    return {
      imageUrl: process.env.VUE_APP_IMG_URL,
      rateId: null,
      rate1: 0,
      rate2: 0,
      rate3: 0,
      rate4: 0,
      showModal: false,
      isFirefox: false,
      isLoggingDuration: false,
    };
  },
  setup() {
    /* eslint-disable */

    const router = useRouter();
    const route = useRoute();
    const antiCheatEnabled = computed(
      () =>
        process.env.VUE_APP_ANTI_CHEAT_ENABLED === "true" &&
        !(courseRegister.value && courseRegister.value.progressUpdate == 100),
    );
    const videoSkipEnabled = process.env.VUE_APP_VIDEO_SKIP === "true";
    const isDevEnabled = process.env.VUE_APP_IS_DEV === "true";
    const skipVideo = () => {
      if (videoRef.value && typeof videoRef.value.pause === "function") {
        videoRef.value.pause();
      }
      updateProgress();
    };
    const skipChapter = (secId, chId) => {
      console.log("skipChapter", secId, chId);
      currentUpdate.value = {
        sectionId: secId,
        chapterId: chId,
        flgSuccess: false,
      };
      updateProgress();
    };
    const pendingQuiz = ref<any>(null);
    const showLeaveWarning = async () => {
      if (!antiCheatEnabled.value) return;
      if (Swal.isVisible()) {
        const currentQuiz = pendingQuiz.value;
        if (currentQuiz) {
          quizInterrupted.value = true;
          Swal.close();
          if (videoRef.value && !videoRef.value.paused) {
            videoRef.value.pause();
          }
          await Swal.fire({
            title: "ระบบตรวจพบการออกจากหน้าเรียน",
            text: "กรุณาอยู่ในหน้าบทเรียนขณะที่กำลังเรียน",
            icon: "warning",
            confirmButtonText: "กลับสู่บทเรียน",
            confirmButtonColor: "#323563",
            allowOutsideClick: false,
            allowEscapeKey: false,
          });
          showChapterQuiz(currentQuiz);
        }
        return;
      }
      if (videoRef.value && !videoRef.value.paused) {
        videoRef.value.pause();
      }
      Swal.fire({
        title: "ระบบตรวจพบการออกจากหน้าเรียน",
        text: "กรุณาอยู่ในหน้าบทเรียนขณะที่กำลังเรียน",
        icon: "warning",
        confirmButtonText: "กลับสู่บทเรียน",
        confirmButtonColor: "#323563",
        allowOutsideClick: false,
        allowEscapeKey: false,
      });
    };

    const handleVisibilityChange = () => {
      if (!antiCheatEnabled.value) return;
      if (window.document.hidden) {
        showLeaveWarning();
      }
    };

    const handleWindowBlur = () => {
      if (!antiCheatEnabled.value) return;
      showLeaveWarning();
    };

    const blockNewTab = (e: MouseEvent) => {
      if (!antiCheatEnabled.value) return;
      if (e.ctrlKey || e.metaKey || e.shiftKey || e.button === 1) {
        e.preventDefault();
        e.stopPropagation();
      }
    };

    onMounted(() => {
      getDataList();
      if (antiCheatEnabled.value) {
        window.document.addEventListener(
          "visibilitychange",
          handleVisibilityChange,
        );
        window.addEventListener("blur", handleWindowBlur);
        window.document.addEventListener("click", blockNewTab, true);
        window.document.addEventListener("mousedown", blockNewTab, true);
      }
    });

    onUnmounted(() => {
      Swal.close();
      if (videoRef.value && typeof videoRef.value.pause === "function") {
        videoRef.value.pause();
        videoRef.value.src = "";
        videoRef.value.load();
      }
      if (antiCheatEnabled.value) {
        window.document.removeEventListener(
          "visibilitychange",
          handleVisibilityChange,
        );
        window.removeEventListener("blur", handleWindowBlur);
        window.document.removeEventListener("click", blockNewTab, true);
        window.document.removeEventListener("mousedown", blockNewTab, true);
      }
      if (quizTimeoutHandle.value !== null) {
        clearTimeout(quizTimeoutHandle.value);
        quizTimeoutHandle.value = null;
      }
      pendingQuiz.value = null;
      maxReachedTime.value = 0;
      videoReload.value = 0;
      showSeeking.value = false;
      currentVideo.value = undefined;
      currentYoutube.value = undefined;
      listData.value = undefined;
      listSection.value = undefined;
      currentChId.value = undefined;
      showDetail.value = true;
      showDocument.value = false;
      showBookmark.value = false;
      listDocument.value = undefined;
      showYoutube.value = false;
      showVideo.value = false;
      currentUpdate.value = { sectionId: "", chapterId: "", flgSuccess: true };
      courseRegister.value = undefined;
      shownQuizChapters.value = new Set();
    });
    watch(
      () => route.path,
      () => {
        Swal.close();
        if (quizTimeoutHandle.value !== null) {
          clearTimeout(quizTimeoutHandle.value);
          quizTimeoutHandle.value = null;
        }
        pendingQuiz.value = null;
        nextTick(() => {
          getDataList();
        });
      },
    );
    const showChapterQuiz = async (quiz) => {
      pendingQuiz.value = quiz;
      quizInterrupted.value = false;
      const wasPlaying =
        videoRef.value && !videoRef.value.paused && !videoRef.value.ended;
      if (videoRef.value && typeof videoRef.value.pause === "function") {
        videoRef.value.pause();
      }
      const fsElement =
        window.document.fullscreenElement ||
        (window.document as any).webkitFullscreenElement ||
        (window.document as any).mozFullScreenElement ||
        (window.document as any).msFullscreenElement;
      if (fsElement) {
        if (window.document.exitFullscreen) {
          await window.document.exitFullscreen().catch(() => {});
        } else if ((window.document as any).webkitExitFullscreen) {
          (window.document as any).webkitExitFullscreen();
        } else if ((window.document as any).mozCancelFullScreen) {
          (window.document as any).mozCancelFullScreen();
        } else if ((window.document as any).msExitFullscreen) {
          (window.document as any).msExitFullscreen();
        }
      }

      if (quiz.quizUrl) {
        await Swal.fire({
          title: "คำถามท้ายบทเรียน",
          html: `
            <div style="text-align:right;margin-bottom:8px;">
              <a href="${quiz.quizUrl}" target="_blank" rel="noopener noreferrer"
                style="display:inline-flex;align-items:center;gap:6px;padding:6px 14px;background:#323563;color:#fff;border-radius:8px;font-size:14px;text-decoration:none;">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/><polyline points="15 3 21 3 21 9"/><line x1="10" y1="14" x2="21" y2="3"/></svg>
                เปิดลิงก์นี้
              </a>
            </div>
            <iframe src="${quiz.quizUrl}" style="width:100%;height:480px;border:none;border-radius:8px;"></iframe>`,
          confirmButtonText: "ปิด",
          confirmButtonColor: "#323563",
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false,
          showCancelButton: false,
          showCloseButton: false,
          width: "800px",
        });
        pendingQuiz.value = null;
        if (
          !quizInterrupted.value &&
          wasPlaying &&
          videoRef.value &&
          typeof videoRef.value.play === "function"
        ) {
          videoRef.value.play();
        }
        return;
      }

      const choicesHtml = (quiz.questionChoices || [])
        .map(
          (c, i) => `
            <label style="display:block;text-align:left;padding:10px;border:1px solid #ddd;border-radius:8px;margin:6px 0;cursor:pointer;">
              <input type="radio" name="quizChoice" value="${
                c.choiceId
              }" data-correct="${c.flgAnswer}" style="margin-right:8px;" />
              ${i + 1}. ${c.textChoice}
            </label>`,
        )
        .join("");

      const result = await Swal.fire({
        title: "คำถามท้ายบทเรียน",
        html: `
          <p style="text-align:left;font-weight:600;">${quiz.textQuestion ||
            ""}</p>
          ${
            quiz.imageQuestion
              ? `<img src="${process.env.VUE_APP_IMG_URL +
                  quiz.imageQuestion}" style="max-width:100%;margin:10px 0;" />`
              : ""
          }
          <div id="quizChoices">${choicesHtml}</div>
        `,
        confirmButtonText: "ส่งคำตอบ",
        confirmButtonColor: "#323563",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showCancelButton: false,
        showCloseButton: false,
        preConfirm: () => {
          const selected = window.document.querySelector(
            'input[name="quizChoice"]:checked',
          ) as HTMLInputElement | null;
          if (!selected) {
            Swal.showValidationMessage("กรุณาเลือกคำตอบก่อนส่ง");
            return false;
          }
          return {
            choiceId: selected.value,
            isCorrect: selected.dataset.correct === "true",
          };
        },
      });

      const isCorrect = result.value ? result.value.isCorrect : false;
      await Swal.fire({
        title: isCorrect ? "คำตอบถูกต้อง" : "คำตอบไม่ถูกต้อง",
        icon: isCorrect ? "success" : "error",
        confirmButtonText: "ตกลง",
        confirmButtonColor: "#323563",
        allowOutsideClick: false,
        allowEscapeKey: false,
      });

      pendingQuiz.value = null;
      if (
        !quizInterrupted.value &&
        wasPlaying &&
        videoRef.value &&
        typeof videoRef.value.play === "function"
      ) {
        videoRef.value.play();
      }
    };
    const getDataList = async () => {
      const getSyllabus = await axios.get(
        process.env.VUE_APP_API_URL + "/getSyllabus?id=" + route.params.sbId,
        {
          headers: {
            token: localStorage.getItem("id_token"),
          },
        },
      );
      showVideo.value = false;
      axios
        .get(
          process.env.VUE_APP_API_URL + "/getCourse?id=" + route.params.cId,
          // "&categories=" +
          // categories.value
          {
            headers: {
              token: localStorage.getItem("id_token"),
            },
          },
        )
        .then((response) => {
          // console.log(response.data.data.content[0]);
          if (response.data.data.content?.length > 0) {
            listData.value = response.data.data.content[0];
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            getChapterList();
            setCurrentPageBreadcrumbs(listData.value.title, [
              getSyllabus.data.data.content?.[0]?.name,
            ]);
          }
        })
        .catch((error) => {
          // console.log(error);
        });
    };
    const getChapterList = () => {
      axios
        .get(
          process.env.VUE_APP_API_URL +
            "/getCourseSection?courseId=" +
            route.params.cId,
          {
            headers: {
              token: localStorage.getItem("id_token"),
            },
          },
        )
        .then((response) => {
          // console.log(response.data.data.content);
          listSection.value = response.data.data.content;
          // eslint-disable-next-line @typescript-eslint/no-use-before-define
          // videoExam(listData.value.chapter.chapterId, false);
        })
        .catch((error) => {
          // console.log(error);
        });
    };
    const getDocuments = () => {
      axios
        .get(
          process.env.VUE_APP_API_URL +
            "/api/v1/courses/" +
            route.params.id +
            "/documents",
          {
            headers: {
              token: localStorage.getItem("id_token"),
            },
          },
        )
        .then((response) => {
          listDocument.value = response.data.result[0].downloadFiles;
          // console.log(response.data.result[0].downloadFiles);
        })
        .catch((error) => {
          // console.log(error);
        });
    };
    const getBookmark = () => {
      axios
        .get(
          process.env.VUE_APP_API_URL +
            "/api/v1/courses/" +
            route.params.id +
            "/bookmark",
          {
            headers: {
              token: localStorage.getItem("id_token"),
            },
          },
        )
        .then((response) => {
          // console.log(response.data.result);
          if (response.data.result.length > 0) {
            showBookmark.value = true;
          } else {
            showBookmark.value = false;
          }
        })
        .catch((error) => {
          // console.log(error);
        });
    };
    const videoExam = async (secId, chId, autoPlay) => {
      window.scrollTo({ top: 0, behavior: "smooth" });
      maxReachedTime.value = 0;
      currentUpdate.value = {
        sectionId: secId,
        chapterId: chId,
        flgSuccess: true,
      };
      showVideo.value = true;
      showYoutube.value = false;
      currentChId.value = chId;
      if (!Array.isArray(listSection.value)) return;
      let flgSuccess = false;
      let chapterQuiz: any = null;
      let chapterQuizTime = 0;
      for (const loopSection of listSection.value) {
        if (secId == loopSection.id) {
          for (const loopChapter of loopSection.chapters) {
            if (loopChapter.chapterId == chId) {
              currentVideo.value =
                process.env.VUE_APP_IMG_URL + loopChapter.videoPath;
              flgSuccess =
                loopChapter.flgSuccess == true ||
                !!(
                  courseRegister.value &&
                  courseRegister.value.status == 3 &&
                  courseRegister.value.progressUpdate == 100
                );
              currentUpdate.value.flgSuccess = flgSuccess;
              showSeeking.value = flgSuccess;
              videoReload.value += 1;

              if (loopChapter.quizUrl) {
                chapterQuiz = { quizUrl: loopChapter.quizUrl };
                chapterQuizTime = loopChapter.quizTime;
              } else if (loopChapter.quiz && loopChapter.quiz.textQuestion) {
                chapterQuiz = loopChapter.quiz;
                chapterQuizTime = loopChapter.quizTime;
              }
            }
          }
        }
      }
      if (flgSuccess != true) {
        let currentTime = await axios.get(
          process.env.VUE_APP_API_URL +
            `/getCourseVideoProgress?courseId=${route.params.cId}&sectionId=${secId}&chapterId=${chId}`,
          {
            headers: {
              token: localStorage.getItem("id_token"),
            },
          },
        );
        if (currentTime.data.data.length > 0) {
          const elapsed = currentTime.data.data[0].elapsed;
          videoRef.value.addEventListener(
            "loadedmetadata",
            () => {
              videoRef.value.seekTo(elapsed);
            },
            { once: true },
          );
        }
      }
      if (videoRef.value) {
        videoRef.value.load();
      }
      if (autoPlay == true) {
        setTimeout(() => {
          if (videoRef.value) videoRef.value.play();
        }, 1000);
      }
      const quizKey = `${secId}_${chId}`;
      if (quizTimeoutHandle.value !== null) {
        clearTimeout(quizTimeoutHandle.value);
        quizTimeoutHandle.value = null;
      }
      if (chapterQuiz && !shownQuizChapters.value.has(quizKey)) {
        console.log(
          "Scheduling quiz for chapter",
          chId,
          "in",
          chapterQuizTime,
          "seconds",
        );
        const delayMs = (Number(chapterQuizTime) || 0) * 1000;
        quizTimeoutHandle.value = window.setTimeout(() => {
          if (currentUpdate.value.chapterId !== chId) return;
          shownQuizChapters.value.add(quizKey);
          showChapterQuiz(chapterQuiz);
        }, delayMs);
      }
    };
    const getExam = (secId, chId, exId, pretest) => {
      window.scrollTo({ top: 0, behavior: "smooth" });
      // หยุดวิดีโอและ clear currentUpdate ก่อน เพื่อกัน @ended trigger updateProgress หลังออกจากหน้า
      if (videoRef.value && typeof videoRef.value.pause === "function") {
        videoRef.value.pause();
      }
      currentUpdate.value = { sectionId: "", chapterId: "", flgSuccess: true };
      Swal.fire({
        title: "แบบทดสอบก่อนเรียน",
        text:
          "ระบบจะจับเวลาและบันทึกการทำข้อสอบทันที เมื่อคุณกดปุ่มเริ่มทำข้อสอบ",
        icon: "warning",
        showCancelButton: false,
        confirmButtonColor: "#323563",
        cancelButtonColor: "#d33",
        allowOutsideClick: false,
        confirmButtonText: "เข้าใจและเริ่มทำข้อสอบ",
        // cancelButtonText: "ยกเลิก",
      }).then((result) => {
        if (result.isConfirmed) {
          localStorage.setItem("reloaded", "1");
          router.push({
            name: "mandatory-exam",
            params: {
              sbId: route.params.sbId,
              cId: route.params.cId,
              secId: secId,
              chId: chId,
              exId: exId,
              type: pretest == true ? "pretest" : "posttest",
            },
          });
        }
      });
    };
    // const postExam = (chId, exId) => {
    //   Swal.fire({
    //     title:
    //       "ระบบจะจับเวลาและบันทึกการทำข้อสอบทันที เมื่อคุณกดปุ่มเริ่มทำข้อสอบ",
    //     text:
    //       "เกณฑ์การตัดสิน : คุณต้องได้คะแนนสอบมากกว่า 60% และทำข้อสอบได้ไม่เกิน 3 ครั้ง หากไม่ผ่าน ความคืบหน้าในบทเรียนนั้นจะถูกรีเซ็ตเป็น 0",
    //     icon: "warning",
    //     showCancelButton: false,
    //     confirmButtonColor: "#323563",
    //     cancelButtonColor: "#d33",
    //     allowOutsideClick: false,
    //     confirmButtonText: "เข้าใจและเริ่มทำข้อสอบ",
    //     // cancelButtonText: "ยกเลิก",
    //   }).then((result) => {
    //     if (result.isConfirmed) {
    //       router.push({
    //         name: "voluntary-exam",
    //         params: {
    //           cId: route.params.id,
    //           chId: chId,
    //           exId: exId,
    //           type: "posttest",
    //         },
    //       });
    //     }
    //   });
    // };
    const detail = () => {
      showDetail.value = true;
      showDocument.value = false;
    };
    const document = () => {
      showDetail.value = false;
      showDocument.value = true;
    };
    const bookmark = () => {
      const formData = new FormData();
      formData.append("syllabusId", "-1");
      formData.append(
        "bookmark",
        showBookmark.value == true ? "false" : "true",
      );
      axios
        .post(
          process.env.VUE_APP_API_URL +
            "/api/v1/courses/" +
            route.params.id +
            "/chapter/" +
            currentChId.value +
            "/bookmark",
          formData,
          {
            headers: {
              token: localStorage.getItem("id_token"),
            },
          },
        )
        .then((res) => {
          getBookmark();
        })
        .catch((error) => {
          // console.log(error);
        });
    };
    const share = (social) => {
      const url = new URL(window.location.href);
      if (social == "facebook") {
        window.open(
          "http://facebook.com/sharer/sharer.php?u=" +
            encodeURIComponent(url.href),
          "",
          "left=0,top=0,width=650,height=420,personalbar=0,toolbar=0,scrollbars=0,resizable=0",
        );
      } else if (social == "twitter") {
        window.open(
          "http://www.twitter.com/share?url=" + encodeURIComponent(url.href),
          "",
          "left=0,top=0,width=650,height=420,personalbar=0,toolbar=0,scrollbars=0,resizable=0",
        );
      } else {
        window.open(
          "https://social-plugins.line.me/lineit/share?url=" +
            encodeURIComponent(url.href),
          "",
          "left=0,top=0,width=650,height=420,personalbar=0,toolbar=0,scrollbars=0,resizable=0",
        );
      }
    };
    const openFile = (secId, chId, file, type) => {
      window.scrollTo({ top: 0, behavior: "smooth" });
      currentUpdate.value.sectionId = secId;
      currentUpdate.value.chapterId = chId;
      if (type == "youtube") {
        showVideo.value = false;
        showYoutube.value = true;
        // https://www.youtube.com/embed/
        let idYoutub = file.split("v=")[1];
        currentYoutube.value = "https://www.youtube.com/embed/" + idYoutub;
      } else {
        window.open(process.env.VUE_APP_IMG_URL + file, "_blank");
      }
    };
    const updateProgress = async () => {
      const formData = new FormData();
      console.log("listData", listData);
      if (listData && currentUpdate.value.flgSuccess == false) {
        formData.append("courseId", route.params.cId + "");
        formData.append("sectionId", currentUpdate.value.sectionId);
        formData.append("chapterId", currentUpdate.value.chapterId);
        // console.log("update");
        await axios
          .post(process.env.VUE_APP_API_URL + "/updateProgress", formData, {
            headers: {
              token: localStorage.getItem("id_token"),
            },
          })
          .then(async (res) => {
            if (res.data.code == 200) {
              const getCourseRegister = await axios.get(
                process.env.VUE_APP_API_URL +
                  "/getCourseRegister?userId=" +
                  localStorage.getItem("u_id") +
                  "&courseId=" +
                  route.params.cId,
                {
                  headers: {
                    token: localStorage.getItem("id_token"),
                  },
                },
              );
              if (
                getCourseRegister.data.data.content.length > 0 &&
                getCourseRegister.data.data.content[0].progressUpdate == 100
              ) {
                router.go(0);
              } else {
                getDataList();
              }
            } else {
              if (res.data.message != "คอร์สนี้ท่านอยู่ในสถานะจบหลักสูตรแล้ว") {
                Swal.fire({
                  title: "แจ้งเตือนข้อผิดพลาด",
                  text: res.data.message,
                  icon: "error",
                  buttonsStyling: false,
                  confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
                  customClass: {
                    confirmButton: "btn fw-semobold btn-light-danger",
                  },
                });
              }else{
                 Swal.fire({
                  title: "แจ้งเตือนข้อผิดพลาด",
                  text: res.data.message,
                  icon: "error",
                  buttonsStyling: false,
                  confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
                  customClass: {
                    confirmButton: "btn fw-semobold btn-light-danger",
                  },
                }).then(() => {
                  router.push({
                    name: "mandatory-list",
                    params: { id: route.params.sbId },
                  });
                });
              }
            }
          })
          .catch((error) => {
            // console.log(error);
            Swal.fire({
              title: "แจ้งเตือนข้อผิดพลาด",
              text: error.response.data.message,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-danger",
              },
            });
          });
      }
    };
    return {
      antiCheatEnabled,
      videoSkipEnabled,
      skipVideo,
      isDevEnabled,
      skipChapter,
      getDataList,
      listData,
      listSection,
      getChapterList,
      getBookmark,
      getDocuments,
      videoRef,
      getExam,
      videoExam,
      currentChId,
      showDetail,
      showDocument,
      showBookmark,
      detail,
      document,
      bookmark,
      listDocument,
      share,
      currentVideo,
      openFile,
      showYoutube,
      currentYoutube,
      showVideo,
      updateProgress,
      currentUpdate,
      currentDuration,
      videoReload,
      showSeeking,
      courseRegister,
      shownQuizChapters,
      quizTimeoutHandle,
    };
  },
  async mounted() {
    this.isFirefox = navigator.userAgent.toLowerCase().includes("firefox");
    try {
      const getCourseRegister = await axios.get(
        process.env.VUE_APP_API_URL +
          "/getCourseRegister?userId=" +
          localStorage.getItem("u_id") +
          "&courseId=" +
          this.$route.params.cId,
        {
          headers: {
            token: localStorage.getItem("id_token"),
          },
        },
      );
      const content = getCourseRegister.data?.data?.content;
      courseRegister.value = content?.length > 0 ? content[0] : undefined;
      if (
        content?.length > 0 &&
        content[0].rate == null &&
        content[0].progressUpdate == 100
      ) {
        Swal.fire({
          title: "ยินดีด้วย!",
          text: "คุณได้เรียนจบหลักสูตรแล้ว",
          icon: "success",
          buttonsStyling: false,
          confirmButtonText: "ตกลง",
          showCancelButton: true,
          cancelButtonText: "ให้คะแนน",
          customClass: {
            confirmButton: "btn btn-swal1",
            cancelButton: "btn btn-swal2",
          },
        }).then(async (res) => {
          if (res.isConfirmed != true) {
            this.clickScore(content[0].id);
          }
        });
      }
    } catch (error) {
      // console.log(error);
    }
  },
  methods: {
    onPlay() {
      // axios
      //   .post(
      //     process.env.VUE_APP_API_URL +
      //       "/api/v1/courses/" +
      //       this.$route.params.id +
      //       "/chapters/" +
      //       currentChId.value +
      //       "/progress/content/exam/0/score/0",
      //     {},
      //     {
      //       headers: headers,
      //     }
      //   )
      //   .then((res) => {
      // console.log(res);
      //   })
      //   .catch((error) => {
      // console.log(error);
      //   });
    },
    async logDuration() {
      if (this.isLoggingDuration) return;
      this.isLoggingDuration = true;
      try {
        if (!Array.isArray(listSection.value)) return;
        let flgSuccess = false;
        for (const loopSection of listSection.value) {
          if (currentUpdate.value.sectionId == loopSection.id) {
            for (const loopChapter of loopSection.chapters) {
              if (loopChapter.chapterId == currentUpdate.value.chapterId) {
                flgSuccess = loopChapter.flgSuccess;
              }
            }
          }
        }
        const rawDuration = videoRef.value?.duration;
        const rawElapsed = videoRef.value?.currentTime;
        const duration =
          isFinite(rawDuration) && rawDuration > 0 ? rawDuration : 0;
        const elapsed = isFinite(rawElapsed) ? rawElapsed : 0;
        const formData = new FormData();
        formData.append("courseId", this.$route.params.cId + "");
        formData.append("sectionId", currentUpdate.value.sectionId);
        formData.append("chapterId", currentUpdate.value.chapterId);
        formData.append("duration", String(duration));
        formData.append("elapsed", String(elapsed));
        if (flgSuccess == false) {
          // console.log("[logDuration]", { duration, elapsed, rawDuration: videoRef.value?.duration, rawElapsed: videoRef.value?.currentTime });
          await axios
            .post(
              process.env.VUE_APP_API_URL + "/updateVideoProgress",
              formData,
              {
                headers: { token: localStorage.getItem("id_token") },
              },
            )
            .then((res) => {
              // console.log(res);
            })
            .catch((error) => {
              // console.log(error);
              Swal.fire({
                title: "แจ้งเตือนข้อผิดพลาด",
                text: error.response.data.message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
                customClass: {
                  confirmButton: "btn fw-semobold btn-light-danger",
                },
              });
            });
        }
      } finally {
        this.isLoggingDuration = false;
      }
    },
    formatDate(date) {
      const event = new Date(date);
      return event.toLocaleDateString("th-TH", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    },
    formatDateTime(date) {
      const event = new Date(date);
      return (
        event.toLocaleDateString("th-TH", {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        }) + " น."
      );
    },
    handleData1(data) {
      this.rate1 = data;
    },
    handleData2(data) {
      this.rate2 = data;
    },
    handleData3(data) {
      this.rate3 = data;
    },
    handleData4(data) {
      this.rate4 = data;
    },
    async sentScore() {
      const formData = new FormData();
      formData.append("id", this.rateId + "");
      formData.append("rate1", this.rate1 + "");
      formData.append("rate2", this.rate2 + "");
      formData.append("rate3", this.rate3 + "");
      formData.append("rate4", this.rate4 + "");
      formData.append("remark", "");

      await axios
        .post(process.env.VUE_APP_API_URL + "/updateCourseRate", formData, {
          headers: { token: localStorage.getItem("id_token") },
        })
        .then((res) => {
          if (res.data.code == 200) {
            Swal.fire({
              title: "บันทึกรายการสำเร็จ",
              text: "รายการข้อมูลของคุณถูกบันทึกเรียบร้อยแล้ว",
              icon: "success",
              buttonsStyling: false,
              confirmButtonText: "ตกลง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-primary",
              },
            }).then(() => {
              this.$router.go(0);
            });
          } else {
            Swal.fire({
              title: "แจ้งเตือนข้อผิดพลาด",
              text: res.data.message,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
              customClass: {
                confirmButton: "btn fw-semobold btn-light-danger",
              },
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            title: "แจ้งเตือนข้อผิดพลาด",
            text: error.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "กรุณาลองใหม่ภายหลัง!",
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });
    },
    async clickScore(rateId) {
      this.rateId = rateId;
      this.rate1 = 0;
      this.rate2 = 0;
      this.rate3 = 0;
      this.rate4 = 0;
      const modal_score = document.getElementById("kt_modal_score")!;
      const modal = new Modal(modal_score);
      modal.show();
      modal.hide();
    },
    checkBeforSuccess(indexS, indexC) {
      // console.log("checkBeforSuccess : " + indexS, indexC);
      if (listData.value && listData.value.flgSkipChapter == true) {
        return false;
      }
      if (indexS > 0) {
        if (indexC > 0) {
          if (
            listSection.value[indexS].chapters[indexC - 1].flgSuccess ==
              false &&
            courseRegister.value?.progressUpdate != 100
          ) {
            return true;
          } else {
            return false;
          }
        } else {
          if (
            listSection.value[indexS - 1].chapters[
              listSection.value[indexS - 1].chapters.length - 1
            ].flgSuccess == false &&
            courseRegister.value?.progressUpdate != 100
          ) {
            return true;
          } else {
            return false;
          }
          // return listSection.value[indexS - 1].chapters[
          //   listSection.value[indexS - 1].chapters.length - 1
          // ].flgSuccess == false
          //   ? true
          //   : false;
        }
      } else {
        if (indexC > 0) {
          if (
            listSection.value[indexS].chapters[indexC - 1].flgSuccess ==
              false &&
            courseRegister.value?.progressUpdate != 100
          ) {
            return true;
          } else {
            return false;
          }
          // return listSection.value[indexS].chapters[indexC - 1].flgSuccess ==
          //   false
          //   ? true
          //   : false;
        } else {
          return false;
        }
      }
    },
  },
});
